export enum MaiChatEvents {
  chatViewed = 'Mai Chat Viewed',
  messageSent = 'Mai Chat Message Sent',
  responseCompleted = 'Mai Chat Response Completed',
  responseRatedPositively = 'Mai Chat Response Rated Positively',
  responseRatedNegatively = 'Mai Chat Response Rated Negatively',
  responseRatingRetracted = 'Mai Chat Response Rating Retracted',
  negativeFeedbackSubmitted = 'Mai Chat Negative Feedback Submitted',
  sessionEnded = 'Mai Chat Session Ended',
  toolStepsExpanded = 'Mai Chat Tool Steps Expanded',
  toolStepsCollapsed = 'Mai Chat Tool Steps Collapsed',
  negativeFeedbackCancelled = 'Mai Chat Negative Feedback Cancelled',
  responseRegenerated = 'Mai Chat Response Regenerated',
  errorShown = 'Mai Chat Error Shown',
  turnRetried = 'Mai Chat Turn Retried',
  historyLoadFailed = 'Mai Chat History Load Failed',
  promptsLoadFailed = 'Mai Chat Prompts Load Failed',
}

// Mai properties are Title Case ('Conversation Id', 'Turn Number'), with one
// deliberate exception: patient id ships as `patientId` to match the rest of Maud,
// so Mai events join against them in Mixpanel. Title Case would be a distinct
// property and cross-domain patient cohorts would silently exclude Mai.

// Properties carry raw measurements only — counts, durations, ids, enums — and
// never a boolean Mixpanel could derive from one of them. An engaged session is
// `Message Count > 0` and a returning one is `History Message Count > 0`, both
// read in Mixpanel; sending those as booleans too gives two properties that can
// disagree after a refactor.

// Reported verbatim as the Message Sent `Trigger` property.
export type MaiSendTrigger = 'Send Button' | 'Enter Key' | 'Suggested Prompt';

// Reported verbatim as the `Error Kind` property on Error Shown / Turn Retried.
export type MaiErrorKindLabel = 'Network' | 'Agent' | 'Interrupted';

// Reported verbatim as the `Rating` property on Response Rating Retracted.
export type MaiRatingLabel = 'Up' | 'Down';

export interface MaiSendMeta {
  trigger: MaiSendTrigger;
  promptId?: string;
}
